import { useQuery } from "@tanstack/react-query";
import { invokeGetApi } from "../utils/utils";

export const useHomeQuery = (token) => {

  return useQuery({
    queryKey: ["homeData"],
    queryFn: async () => {

      const recentAccessed = await invokeGetApi(
        token,
        "recent-accessed/"
      );

      const homeData = await invokeGetApi(
        token,
        "manual-upload/folder-contents/"
      );

      const items = homeData?.data?.items || [];

      const course = items.find((i) => i?.id === "1");
      const profile = items.find((i) => i?.id === "2");

      return {
        recentFiles: recentAccessed,
        itemCount: {
          courseCount: course?.items_count,
          profileCount: profile?.items_count
        }
      };
    },
    enabled: !!token,
    refetchOnWindowFocus: false,
    staleTime: 0
  });
};

export const useRecentAccessed = (token) => {
  return useQuery({
    queryKey: ["recentAccessed"],
    queryFn: () => invokeGetApi(token, "recent-accessed/"),
    enabled: !!token,
    refetchOnWindowFocus: false,
  });
};

export const useHomeCounts = (token) => {
  return useQuery({
    queryKey: ["homeCounts"],
    queryFn: async () => {
      const homeData = await invokeGetApi(
        token,
        "manual-upload/folder-contents/"
      );

      const items = homeData?.data?.items || [];

      const course = items.find((i) => i?.id === "1");
      const profile = items.find((i) => i?.id === "2");

      return {
        courseCount: course?.items_count,
        profileCount: profile?.items_count
      };
    },
    enabled: !!token,
    refetchOnWindowFocus: false,
  });
};